// @flow

import React from "react";
import {
  Form,
  Grid,
  Card,
  Button,
  Icon,
  Page

} from "tabler-react";
import Select from 'react-select';
import SiteWrapperHospitalSuperAdmin from "../SiteWrapper.hospital.superadmin.react";
import clientService from "../../../services/client";
import { validate } from '../../../validate';
import { toast, ToastContainer } from 'react-toastify';
import Buttonloader from '../../../common/Loader/Buttonloader'
import 'react-toastify/dist/ReactToastify.css';
import { changeLanguage } from "../../../language";
import { getAllAppointmentModes, getAllHospitals, getAllSpecializations, getAppointmentModeById, getDoctorById, getHospitalById, getSpecializationById, updateAppointmentMode, updateDoctor, updateHospital, updateSpecialization } from "../../../services/hospital";


const validationRules = [
  {
    field: 'name_en',
    validations: ['required'],
    name: 'Name'
  },
  {
    field: 'name_id',
    validations: ['required'],
    name: 'Name In'
  },
  {
    field: 'id',
    validations: ['required'],
    name: 'Hospital Id'
  },
  {
    field: 'hospital_id',
    validations: ['required'],
    name: 'Hospital'
  },
  {
    field: 'appointment_id',
    validations: ['required'],
    name: 'Appointment'
  },
  {
    field: 'specialization_id',
    validations: ['required'],
    name: 'Specialization'
  },
];

class DoctorEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fields: {
        name_en: '',
        name_id: '',
        id: '',
        _id: '',
        hospital_id: '',
        appointment_id: '',
        specialization_id: '',
      },
      message: {
        style: 'success',
        text: ''
      },
      hospitalArr: [],
      appointmentArr: [],
      isLoading: false,
      errors: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNotification = this.handleNotification.bind(this);
    this.setLoadingToggle = this.setLoadingToggle.bind(this);

  }

  setLoadingToggle(value) {
    this.setState({ isLoading: value })
  }

  //handle change
  handleChange = (e, field) => {
    const { fields } = this.state, val = e.target.value;
    fields[field] = val;
    this.setState({ fields });
    this.validate();
  }


  handleNotification() {
    this.setState(() => ({ message: { text: '', style: '' } }));
  }

  validate() {
    const { fields } = this.state;
    const { isValid, errors } = validate(fields, validationRules);
    this.setState({ errors });
    return isValid;
  }

  componentDidMount() {
    document.title = "Voiceoc | Edit Doctor"
    this.setLoadingToggle(true);
    getAllHospitals()
      .then(res => {
        console.info(res)
        this.setState(() => ({
          hospitalArr: res.data.result,
        }));
      }).catch(err => console.error(err))

    getAllAppointmentModes()
      .then(res => {
        console.info(res)
        this.setState(() => ({
          appointmentArr: res.data.result,
        }));
      }).catch(err => console.error(err))

    getAllSpecializations()
      .then(res => {
        console.info(res)
        this.setState(() => ({
          specializationArr: res.data.result,
        }));
      }).catch(err => console.error(err))

    getDoctorById(this.props.match.params.id).then(res => {
      this.setState({
        fields: {
          id: res.id,
          _id: res._id,
          name_en: res.name_en,
          name_id: res.name_id,
          hospital_id: res.hospital_id,
          appointment_id: res.appointment_id,
          specialization_id: res.specialization_id,
        }
      })
      this.setLoadingToggle(false);

    }).catch(error => {
      if (error.response && error.response.data.message)
        toast.error(error.response.data.message)
      else if (error.message)
        toast.error(error.message)
      else
        toast.error(error)
      this.setLoadingToggle(false);
    })
  }

  //submit form
  handleSubmit = async event => {
    event.preventDefault();

    if (this.validate()) {
      this.setLoadingToggle(true);
      let data = {
        name_en: this.state.fields.name_en,
        name_id: this.state.fields.name_id,
        id: this.state.fields.id,
        hospital_id: this.state.fields.hospital_id,
        appointment_id: this.state.fields.appointment_id,
        specialization_id: this.state.fields.specialization_id,
      }
      updateDoctor(data, this.props.match.params.id)
        .then(response => {
          this.setLoadingToggle(false)
          toast.success("Doctor updated successfully.")
          setTimeout(() => {
            this.props.history.push("/admin/hospitaltabs/doctor/1");
          }, 3000)
        })
        .catch(error => {
          this.setLoadingToggle(false)
          if (error.response && error.response.data.message)
            toast.error(error.response.data.message)
          else if (error.message)
            toast.error(error.message)
          else
            toast.error(error)
        })

    }
  }

  render() {
    return (
      <SiteWrapperHospitalSuperAdmin>
        <Page.Content>
          <Grid.Row>
            <Grid.Col lg={5} className="mx-auto ">
              <Card>
                <Card.Header>
                  <Card.Title>Edit Doctor</Card.Title>
                </Card.Header>
                <Card.Body>
                  <form onSubmit={this.handleSubmit}>
                    <Form.FieldSet>
                      <Form.Group
                        isRequired
                        label={changeLanguage(this.props.siteLanguage, 'name_en')}
                      >
                        <Form.Input name="name_en"
                          onChange={(e) => this.handleChange(e, 'name_en')}
                          placeholder={changeLanguage(this.props.siteLanguage, 'name_en')}
                          value={this.state.fields.name_en} />
                        <label style={{ display: this.state.errors.name_en ? 'block' : 'none' }} className="error">{this.state.errors.name_en}</label>
                      </Form.Group>

                      <Form.Group
                        isRequired
                        label={changeLanguage(this.props.siteLanguage, 'name_id')}
                      >
                        <Form.Input name="name_id"
                          onChange={(e) => this.handleChange(e, 'name_id')}
                          placeholder={changeLanguage(this.props.siteLanguage, 'name_id')}
                          value={this.state.fields.name_id} />
                        <label style={{ display: this.state.errors.name_id ? 'block' : 'none' }} className="error">{this.state.errors.name_id}</label>
                      </Form.Group>
                      <Form.Group
                        isRequired
                        label={changeLanguage(this.props.siteLanguage, 'hospital_id')}
                      >
                        <Form.Input name="Id"
                          onChange={(e) => this.handleChange(e, 'id')}
                          placeholder={changeLanguage(this.props.siteLanguage, 'hospital_id')}
                          value={this.state.fields.id} />
                        <label style={{ display: this.state.errors.id ? 'block' : 'none' }} className="error">{this.state.errors.id}</label>
                      </Form.Group>

                      <Form.Group
                        isRequired
                        label={changeLanguage(this.props.siteLanguage, 'hospital')}
                      >
                        <Form.Select
                          name={changeLanguage(this.props.siteLanguage, 'hospital')}
                          onChange={(e) => this.handleChange(e, 'hospital_id')}
                          value={this.state.fields.hospital_id}
                        >
                          <option value="">
                            {changeLanguage(this.props.siteLanguage, 'please_select_hospital')}
                          </option>
                          {
                            this.state.hospitalArr && this.state.hospitalArr.length && this.state.hospitalArr.map(el => (
                              <option value={el.id}>{el.name_en}</option>
                            ))
                          }
                        </Form.Select>


                        <label style={{ display: this.state.errors.hospital_id ? 'block' : 'none' }} className="error">{this.state.errors.hospital_id}</label>
                      </Form.Group>


                      <Form.Group
                        isRequired
                        label={changeLanguage(this.props.siteLanguage, 'appointment_mode')}
                      >
                        <Form.Select
                          name={changeLanguage(this.props.siteLanguage, 'appointment_mode')}
                          onChange={(e) => this.handleChange(e, 'appointment_id')}
                          value={this.state.fields.appointment_id}
                        >
                          <option value="">
                            {changeLanguage(this.props.siteLanguage, 'please_select_appointment_mode')}
                          </option>
                          {
                            this.state.appointmentArr && this.state.appointmentArr.length && this.state.appointmentArr.filter(elx => elx.hospital_id == this.state.fields.hospital_id).map(el => (
                              <option value={el.id}>{el.name_en}</option>
                            ))
                          }
                        </Form.Select>
                        <label style={{ display: this.state.errors.appointment_id ? 'block' : 'none' }} className="error">{this.state.errors.appointment_id}</label>
                      </Form.Group>

                      <Form.Group
                        isRequired
                        label={changeLanguage(this.props.siteLanguage, 'specialization')}
                      >
                        <Form.Select
                          name={changeLanguage(this.props.siteLanguage, 'specialization')}
                          onChange={(e) => this.handleChange(e, 'specialization_id')}
                          value={this.state.fields.specialization_id}
                        >
                          <option value="">
                            {changeLanguage(this.props.siteLanguage, 'please_select_specialization')}
                          </option>
                          {
                            this.state.specializationArr && this.state.specializationArr.length && this.state.specializationArr.filter(elx => elx.appointment_id == this.state.fields.appointment_id).map(el => (
                              <option value={el.id}>{el.name_en}</option>
                            ))
                          }
                        </Form.Select>
                        <label style={{ display: this.state.errors.specialization_id  ? 'block' : 'none' }} className="error">{this.state.errors.specialization_id}</label>
                      </Form.Group>



                    </Form.FieldSet>
                    {!this.state.isLoading ?
                      <Button color="primary btn-block" type="submit">Update</Button>
                      :
                      <Buttonloader loading={this.state.isLoading}></Buttonloader>
                    }
                  </form>
                  <ToastContainer autoClose={5000} position={'bottom-right'} />
                </Card.Body>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Page.Content>
      </SiteWrapperHospitalSuperAdmin >
    )
  }
}

export default DoctorEdit;

